import { Component } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-my-payments',
  templateUrl: './my-payments.component.html',
  styleUrls: ['./my-payments.component.css']
})
export class MyPaymentsComponent {
  userId = '';
  constructor(private userService: UserService, private userInfoService: UserInfoService) {
    this.userId = this.userInfoService.getUserId();
  }

  ngOnInit() {
    this.getMyPayments();
  }

  getMyPayments() {
    this.userService.getMyPayments().subscribe((payments: any) => {
      console.log('My Payments:', payments);
    });
  }
}
